<div class="SubscribeButton">
    <h3>Read the full report</h3>
    <div class="ButtonContainer">
        <a [routerLink]="['/site/upgradeSubscription']" [queryParams]="{service : ('uishared.services.'+subscriptionInfo.service) | transloco , uniqueNumber : subscriptionInfo.uniqueNumber, company : subscriptionInfo.company}" target="secondaryTab" class="Button">Become a subscriber</a>
    </div>
    <!-- <p class="LoginLink">Already a subscriber? <a href="#">Log in</a></p> -->
</div>
